/*******************************************************************************
 * Service */
/**
 * @ngdoc   service
 * @module  csm.books.returnReceipts.
 * @name    csm.books.returnReceipts.service:Services
 * @description
 * Service connection to the server.
 *******************************************************************************/
/* @ngInject */ export function ReturnReceiptsService(CSMHttp) {
  var mBase = '/books/returns/';
  var get = function (route, params, data) {
    return CSMHttp.routing.get(mBase + route, params, data).then(resolve);
  };
  var post = function (route, params, data) {
    return CSMHttp.routing.post(mBase + route, params, data).then(resolve);
  };

  /** Data resolution function (sugar). */ function resolve(response) {
    return response.data;
  }

  return {
    defaultRoute: '/',
    search: function (filter) {
      return post('find', null, filter);
    }
  };
}
